/* Filora — progressive enhancement only. Every effect here is decorative;
   the page is complete and readable without this file. */
(function () {
  var root = document.documentElement;
  root.classList.add('filora-js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveals ------------------------------------------------ */
  function reveal() {
    var items = document.querySelectorAll('.filora-reveal');
    if (reduceMotion || !('IntersectionObserver' in window) || !items.length) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---- Gold thread ----------------------------------------------------
     Maps scroll progress (0 at the top, 1 at the bottom) onto the thread's
     stroke offset. Updates are coalesced into one write per animation frame,
     and scroll listening is passive, so this never blocks scrolling. */
  function thread() {
    if (!document.querySelector('.filora-thread')) return;
    if (reduceMotion) {
      root.style.setProperty('--filora-thread', '1');
      return;
    }
    var ticking = false;
    function update() {
      var max = root.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 1;
      root.style.setProperty('--filora-thread', p.toFixed(4));
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---- Header: pinned bar, condensing lockup ----------------------------
     The announcement bar and header stay pinned. Past a short scroll the
     header gains .filora-condensed and the lockup moves from stacked-centre
     to side-by-side on the left (layout lives in section-filora.css). The
     move is animated FLIP-style per image. The height the header gives up
     is added back as margin-bottom so the page underneath does not jump.
     Thresholds differ (in at 120px, out at 24px) so it never flickers. */
  function header() {
    var section = document.querySelector('.section-header');
    var announce = document.querySelector('.announcement-bar-section');
    if (!section) return;

    function setAnnounceHeight() {
      root.style.setProperty('--filora-announce-h', (announce ? announce.offsetHeight : 0) + 'px');
    }
    setAnnounceHeight();
    if (announce && 'ResizeObserver' in window) new ResizeObserver(setAnnounceHeight).observe(announce);

    if (!section.querySelector('.filora-lockup')) return;
    var parts = section.querySelectorAll('.filora-lockup__mark, .filora-lockup__word');
    var condensed = false;
    var ticking = false;

    function toggle(on) {
      condensed = on;
      var before = [];
      parts.forEach(function (el) {
        before.push(el.getBoundingClientRect());
      });
      var h0 = section.offsetHeight;
      section.style.marginBottom = '';
      section.classList.toggle('filora-condensed', on);
      var h1 = section.offsetHeight;
      if (on && h0 > h1) section.style.marginBottom = h0 - h1 + 'px';
      root.style.setProperty('--header-height', h1 + 'px');

      if (reduceMotion) return;
      parts.forEach(function (el, i) {
        var a = before[i];
        var b = el.getBoundingClientRect();
        if (!b.width) return;
        el.style.transition = 'none';
        el.style.transformOrigin = '0 0';
        el.style.transform =
          'translate(' + (a.left - b.left) + 'px,' + (a.top - b.top) + 'px) scale(' + a.width / b.width + ')';
        el.getBoundingClientRect();
        el.style.transition = 'transform 420ms cubic-bezier(0.22, 0.61, 0.36, 1)';
        el.style.transform = '';
      });
    }

    function update() {
      var y = window.scrollY;
      if (!condensed && y > 120) toggle(true);
      else if (condensed && y < 24) toggle(false);
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  function init() {
    reveal();
    thread();
    header();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
